// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperAbstract-cls1___9385f31884e791d9992{/*!*/}.PaperAbstract-cls2__b68af4bfc4e1052bf0d5{display:flex;flex-direction:column;align-self:stretch;grid-gap:8px;gap:8px;grid-gap:var(--spacing-xs-8, 8px);gap:var(--spacing-xs-8, 8px);padding-bottom:8px}.PaperAbstract-cls2__b68af4bfc4e1052bf0d5.PaperAbstract-variant-dense__c59a448ed9db945491df{grid-gap:0;gap:0;padding-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperAbstract-cls1___9385f31884e791d9992",
	"cls2": "PaperAbstract-cls2__b68af4bfc4e1052bf0d5 PaperAbstract-cls1___9385f31884e791d9992",
	"variant-dense": "PaperAbstract-variant-dense__c59a448ed9db945491df"
};
export default ___CSS_LOADER_EXPORT___;
